import { forConversation } from '../channels';
import type { ExtractValues } from '../helpers';
import { Joi, objectSchemaOf, actionCreator } from '../helpers';

export const INTERVENTION_REQUIRED = 'DIALOGUE/INTERVENTION_REQUIRED';

const interventionReason = [
  'error',
  'timeout',
  'intent',
  'fallback',
  'confidence',
  'hil-takeover',
] as const;

export type InterventionReason = ExtractValues<typeof interventionReason>;

export const interventionReasonSchema = Joi.string().valid(
  ...interventionReason
);

export interface IInterventionRequiredPayload {
  conversationId: string;
  reason: InterventionReason;
  description?: string;
}

export const interventionRequiredPayloadSchema = objectSchemaOf<IInterventionRequiredPayload>(
  {
    conversationId: Joi.string().required(),
    reason: interventionReasonSchema.required(),
    description: Joi.string().optional(),
  }
);

export const interventionRequiredActionSchema = objectSchemaOf<IInterventionRequiredAction>(
  {
    type: Joi.string().required().valid(INTERVENTION_REQUIRED),
    payload: interventionRequiredPayloadSchema.required(),
  }
);

export interface IInterventionRequiredAction {
  type: typeof INTERVENTION_REQUIRED;
  payload: IInterventionRequiredPayload;
}

export const interventionRequired = actionCreator({
  type: INTERVENTION_REQUIRED,
  schema: interventionRequiredActionSchema,
  channels: [forConversation],
});

export type IInterventionRequiredParams = IInterventionRequiredPayload;

export const interventionRequiredParamsSchema = interventionRequiredPayloadSchema;
